module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "manage"
    }
  }, [_c('ul', {
    staticClass: "col-2"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/manage/group/"
    }
  }, [_vm._v("Collections")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/manage/problem/"
    }
  }, [_vm._v("Problems")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/manage/user/"
    }
  }, [_vm._v("Users")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/manage/scoring/"
    }
  }, [_vm._v("Scoring")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/manage/batchuser/"
    }
  }, [_vm._v("Batch User Category")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-621e61e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ManageBoard.vue
// module id = 585
// module chunks = 0